import { render } from "./QuestaoSelecaoVisualizacao.vue?vue&type=template&id=2d7b9a9d&scoped=true&ts=true"
import script from "./QuestaoSelecaoVisualizacao.vue?vue&type=script&lang=ts"
export * from "./QuestaoSelecaoVisualizacao.vue?vue&type=script&lang=ts"

import "./QuestaoSelecaoVisualizacao.vue?vue&type=style&index=0&id=2d7b9a9d&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7b9a9d"]])

export default __exports__